export const AGE_ENGAGEMENT_CHART_OPTIONS = {
    colors: [
        '#F3DBF1',
        '#E9BEE3',
        '#DB97D2',
        '#C76EBA',
        '#AD509E',
        '#8C3F7D',
        '#733567',
        '#733567'
    ],
    
    lang: { noData: 'No data to display' },
    noData: {
        style: {
            fontWeight: 'bold',
            fontSize: '15px',
            color: '#303030'
        }
    },
    chart: {
        type: 'pie',
        backgroundColor: null,
        plotBackgroundColor: null,
        plotBorderWidth: 0,
        plotShadow: false
    },
    title: { text: null },
    subtitle: { text: null },
    exporting: { enabled: false },
    credits: { enabled: false },
    tooltip: {
        useHTML: true,
        backgroundColor: '#000',
        style: {
            color: '#fff',
            fontSize: '10px'
        },
        formatter: function () {
            return `<b>${this.key}</b>: ${this.y}% <br>`;
        }
    },
    legend: {
        useHTML: true,
        layout: 'vertical',
        verticalAlign: 'bottom',
        itemStyle: {
            color: '#667085',
            fontWeight: 400,
            fontSize: '12px'
        },
        labelFormatter() {
            return `${this.options.name} ${this.options.y + '%'}`;
            return `<span>${
                this.options.name
            }</span> <span class="donut-chart-legend-value">${
                this.options.y + '%'
            }</span>`;
            // return `<div class="flex-row justify-space-between">
            //             <div class="donut-chart-legend-segment">${this.options.name}</div>
            //             <div class="donut-chart-legend-value">${this.options.y + '%'} </div>
            //         </div>`
        }
    },
    plotOptions: {
        pie: {
            shadow: false,
            borderWidth: 0,
            allowPointSelect: false,
            size: '100%',
            dataLabels: { enabled: false }
        }
    },
    series: [
        {
            name: 'Physician Engagement Segments',
            data: [
                {
                    name: 'Segment A',
                    y: 19.77
                },
                {
                    name: 'Segment B',
                    y: 27
                },
                {
                    name: 'Segment C',
                    y: 7.98
                },
                {
                    name: 'Segment D',
                    y: 12.17
                },
                {
                    name: 'Segment E',
                    y: 3.8
                },
                {
                    name: 'Infectious Disease Specialist',
                    y: 4.94
                },
                {
                    name: 'Primary HIV HCP',
                    y: 17.11
                },
                {
                    name: 'Not Available',
                    y: 5.32
                }
            ],
            size: '100%',
            innerSize: '50%',
            showInLegend: true,
            borderRadius: 0
        }
    ]
};